import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { webconfig } from '../webconfig';

@Injectable({
  providedIn: 'root'
})
export class RoomenquiryService
{

    ENDPOINTS: any;
    private _session: any;
    constructor(public conn: webconfig, public http: HttpClient) {

        this.ENDPOINTS = conn.getconnectionjava();
    }
    

    getroomcategories(id: any) {
        return new Promise((resolve, reject) => {
            this.http
                .get(this.ENDPOINTS + '/api/roomscategories/' + id)
                .subscribe((data) => {
                    if (data != undefined) {
                        return resolve(data);
                    }
                    return reject(data);
                }, err => {
                    reject(err);
                })
        })
    }

    getroomtypes(id: any, RoomcategoryId:any) {
        return new Promise((resolve, reject) => {
            this.http
                .get(this.ENDPOINTS + '/api/roomstypes/' + id + '/' + RoomcategoryId)
                .subscribe((data) => {
                    if (data != undefined) {
                        return resolve(data);
                    }
                    return reject(data);
                }, err => {
                    reject(err);
                })
        })
    }
    getfacilities(id:any) {
        return new Promise((resolve, reject) => {
            this.http
                .get(this.ENDPOINTS + '/api/facilities/' + id)
                .subscribe((data) => {
                    if (data != undefined) {
                        return resolve(data);
                    }
                    return reject(data);
                }, err => {
                    reject(err);
                })
        })
    }


    Roomsfloors(body:any) {
  
        return new Promise((resolve, reject) => {
          this.http
            .post(this.ENDPOINTS + '/api/roomsfloors', body)
            .subscribe((data) => {
              if (data != undefined) {
                return resolve(data);
              }
              return reject(data);
            }, err => {
              reject(err);
            })
        })
      }
    
      Roomsbyfloorid(body:any) {
  
        return new Promise((resolve, reject) => {
          this.http
            .post(this.ENDPOINTS + '/api/roomsbyfloorid', body)
            .subscribe((data) => {
              if (data != undefined) {
                return resolve(data);
              }
              return reject(data);
            }, err => {
              reject(err);
            })
        })
      }

      bedsbyroomid(body:any) {
  
        return new Promise((resolve, reject) => {
          this.http
            .post(this.ENDPOINTS + '/api/bedsbyroomid', body)
            .subscribe((data) => {
              if (data != undefined) {
                return resolve(data);
              }
              return reject(data);
            }, err => {
              reject(err);
            })
        })
      }
    



}
export interface ResponseObj {
    data: any[],
    status: string,
    errorMessage: string,
}
